import React, { Component } from "react";
import PrintPreview from "../PrintPreview";
import ReportStore from "stores/ReportStore";
import "./Print.css";

const DEFAULT_ROW = 41;
class PrintReportStockMixPaint extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      loading: false,
      dataList: [],
      data: [],
      report_title: "กำลังดึงข้อมูล..",
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("landscape");
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    if (
      this.props.isRange == "false" &&
      this.props.year != undefined &&
      this.props.month != undefined &&
      this.props.day != undefined
    ) {
      ReportStore.loadMixPaintList(
        this.props.year,
        this.props.month,
        this.props.day,
        "",
        "",
        "",
        "",
        (result) => {
          this.setState({
            data: result.data,
            dataList: this.getPagination(result.data),
            report_title: "ไม่พบข้อมูล",
          });
        }
      );
    } else if (
      this.props.isRange == "true" &&
      this.props.startDate != undefined &&
      this.props.endDate != undefined
    ) {
      ReportStore.loadMixPaintListRange(
        this.props.startDate,
        this.props.endDate,
        "",
        "",
        "",
        "",
        (result) => {
          this.setState({
            data: result.data,
            dataList: this.getPagination(result.data),
            report_title: "ไม่พบข้อมูล",
          });
        }
      );
    } else {
      this.setState({
        data: [],
        dataList: this.getPagination([]),
        report_title: "ไม่พบข้อมูล",
      });
    }
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getSummary() {
    let { data } = this.state;
    const total = 0;
    data.forEach((item, index) => {
      total + item.amount == "" ||
      item.amount == null ||
      item.amount == undefined ||
      isNaN(item.amount)
        ? 0
        : parseFloat(item.amount);
    });
    return total;
  }

  getPagination(data) {
    let newData = [];
    let allData = [];
    let checkRow = 0;
    data.forEach(function (item, index) {
      if (checkRow < DEFAULT_ROW) checkRow++;
      newData.push(item);

      if (checkRow === DEFAULT_ROW - 1 || index === data.length - 1) {
        allData.push(newData);
        checkRow = 0;
        newData = [];
      }
    });

    return allData;
  }

  renderRowData(data, indexs) {
    if (data.length == 0) {
      return (
        <tr>
          <td colSpan={8}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          {/* <td className='text-left'>{item.doc_date}</td> */}
          <td className="text-left">{item.mixpaint_no}</td>
          <td className="text-left">{item.work_no}</td>
          <td className="text-left">{item.car_registration_no}</td>
          <td className="text-left">{item.brand}</td>
          <td className="text-left">{item.model}</td>
          <td className="text-left">{item.mixed_by}</td>
          <td className="text-left">{item.request_by}</td>
          <td className="text-left">{item.colorcode}</td>
          <td className="text-left">{item.description}</td>
        </tr>
      ));
    }
  }

  renderTable(item, index) {
    return (
      <table className="table table-print-report-material">
        <tbody>
          <tr>
            {/* <td className='text-center' style={{width:'150px'}}>วันที่เบิก</td> */}
            <td className="text-center" style={{ width: "auto" }}>
              เอกสารที่
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              ใบงานซ่อม
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              ทะเบียนรถ
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              ยี่ห้อ
            </td>
            <td className="text-center" style={{ width: "150px" }}>
              รุ่น
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              ช่างผสมสี
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              ช่างเบิก
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              รหัสสี
            </td>
            <td className="text-center" style={{ width: "auto" }}>
              อธิบาย (หมายเหตุ)
            </td>
          </tr>
          {this.renderRowData(item, index)}
        </tbody>
      </table>
    );
  }

  renderComponentPage(item, index) {
    return (
      <div className="font-print" key={index}>
        <header className="text-center">
          <h2>{this.props.title}</h2>
        </header>
        <div>{this.renderTable(item, index)}</div>
      </div>
    );
  }

  renderNoData() {
    return (
      <div className="font-print">
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    );
  }

  render() {
    let { loading, dataList } = this.state;
    if (dataList.length == 0) {
      return (
        <PrintPreview
          loading={loading}
          leftBarTitle={this.props.title}
          size={"landscape"}
        >
          {this.renderNoData()}
        </PrintPreview>
      );
    } else {
      return (
        <PrintPreview
          loading={loading}
          leftBarTitle={this.props.title}
          size={"landscape"}
        >
          {dataList.map((item, index) => {
            return this.renderComponentPage(item, index);
          })}
        </PrintPreview>
      );
    }
  }
}

PrintReportStockMixPaint.defaultProps = {
  title: "ตารางรายงานการเบิกแม่สีผสม",
  mode: "",
  workNo: "",
};
export default PrintReportStockMixPaint;



// WEBPACK FOOTER //
// ./src/view/print/material/PrintReportStockMixPaint.js